import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-ranking-filial',
  templateUrl: './ranking-filial.component.html',
  styleUrls: ['./ranking-filial.component.css']
})
export class RankingFilialComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';

  tableRanking = new Array();
  tableRankingTotal = new Array();
  loading: boolean = false;
  errorApi: boolean = false;
  message: string = '';

  constructor(private api: ApiService) { }

  ngOnInit() {
  }

  abreviarValor(value: any) {
    if (value < 1000) {
      return 'R$ ' + value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    }
  
    if (value < 1000000) {
      return 'R$ ' + (value / 1000).toFixed(2) + 'k';
    }
  
    return 'R$ ' + (value / 1000000).toFixed(2) + 'kk';
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    let dataRetorno = [];
    this.tableRanking = [];
    this.tableRankingTotal = [];
    if (item.branch != undefined) {
      this.rankingMethod(item).subscribe(data => {
        try {
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            dataRetorno = data.dataRow;
            dataRetorno.map((el: any) => {
              this.tableRanking.push({
                'Código': el.branchCode,
                'Filial': el.branch_name,
                'Ticket Médio': this.abreviarValor(parseFloat(el.tm)),
                'PMPV': this.abreviarValor(parseFloat(el.pmpv)),
                'PA': parseFloat(el.pa).toFixed(2).replace("." , ","),
                'Total': this.abreviarValor(parseFloat(el.invoice_value)),
                'Dinheiro': this.abreviarValor(parseFloat(el.cash_value)),
                'Pix': this.abreviarValor(parseFloat(el.pix_value)),
                'Débito': this.abreviarValor(parseFloat(el.debit_value)),
                'Crédito': this.abreviarValor(parseFloat(el.credit_value)),
                'Fatura': this.abreviarValor(parseFloat(el.installment_value)),
                'Outros': this.abreviarValor(parseFloat(el.other_value)),
              })
              excelInfo.push({
                'Data Inicial': item.dataMin,
                'Data Final': item.dataMax,
                'Código Filiais':item.branch.toString(),
                'Código': el.branchCode,
                'Filial': el.branch_name,
                'Ticket Médio': 'R$ ' + el.tm.toString(),
                'PMPV': 'R$ ' + el.pmpv.toString(),
                'PA': parseFloat(el.pa).toFixed(2).replace("." , ","),
                'Total': 'R$ ' + el.invoice_value.toString(),
                'Dinheiro': 'R$ ' + el.cash_value.toString(),
                'Pix': 'R$ ' + el.pix_value.toString(),
                'Débito': 'R$ ' + el.debit_value.toString(),
                'Crédito': 'R$ ' + el.credit_value.toString(),
                'Fatura': 'R$ ' + el.installment_value.toString(),
                'Outros': 'R$ ' + el.other_value.toString(),
              })
            });
            this.tableRankingTotal.push({
              '            ': 'TOTAL',
              'Ticket Médio': this.abreviarValor(parseFloat(data.tm)),
              'PMPV': this.abreviarValor(parseFloat(data.pmpv)),
              'PA': parseFloat(data.pa).toFixed(2).replace("." , ","),
              'Total': this.abreviarValor(parseFloat(data.invoiceValue)),
              'Dinheiro': this.abreviarValor(parseFloat(data.cash_value)),
              'Pix': this.abreviarValor(parseFloat(data.pix_value)),
              'Débito': this.abreviarValor(parseFloat(data.debit_value)),
              'Crédito': this.abreviarValor(parseFloat(data.credit_value)),
              'Fatura': this.abreviarValor(parseFloat(data.installment_value)),
              'Outros': this.abreviarValor(parseFloat(data.other_value)),
            });
            this.loading = false;
            excelInfo.unshift({});
            localStorage.setItem('ranking-filial', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_FILIAL;
            this.formatErrorMensagem(this.message);
            this.errorApi = true;
          }
          this.loading = false;
        } catch (error: unknown) {
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_FILIAL;
        this.formatErrorMensagem(error.message);
      })
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataRankingFilial = [];
    let objectRankingFilial = localStorage.getItem('ranking-filial');

    objectRankingFilial != null
      ? (dataRankingFilial = JSON.parse(objectRankingFilial))
      : (dataRankingFilial = []);
    const worksheetRankingFilial= XLSX.utils.json_to_sheet(dataRankingFilial);

    const workbook = {
      Sheets: {
        'ranking-loja': worksheetRankingFilial,
      },
      SheetNames: [
        'ranking-loja',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-ranking-loja' + EXCEL_EXTENSION);
  }

  rankingMethod(item: any) {
    return this.api.postBranchRanking(item.dataMin, item.dataMax, item.branch);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: ranking-filial \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
